export const MyBetsTrackingLocation = 'My Bets';
export const myBetsTrackingConstants = {
    SCOREBOARD: 'scoreboard' as const,
    MY_BETS: 'mybets' as const,
};
